import React, { useState, useContext, useRef } from 'react';
import Banner from '../../b2b-common/Banner';
import { LoginContext } from '../../../App';
import B2BFormContainer from '../../b2b-common/B2BFormContainer';
import { importingCSVFile } from '../../../services/b2b-languages-apiService';
import B2BDialog from '../../b2b-common/B2BDialog';
import { callAPIWhileSettingState } from '../../b2b-common/helpers';
import { FileUpload } from '@mui/icons-material';

import './CSVImportPage.css';
import { Checkbox, Divider } from '@mui/material';

const CSVImportPage = () => {
    const { loginData } = useContext(LoginContext);

    const csvFileInputRef = useRef(null);
    const [processingCSVFile, setProcessingCSVFile] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogError, setDialogError] = useState(null);
    const [columnSeparator, setColumnSeparator] = useState('|');
    const [prioritizeCSV, setPrioritizeCSV] = useState(true);


    const handleCSVFileUpload = async (e) => {
        const paramsArray = [
            e.target.files[0],
            prioritizeCSV,
            columnSeparator,
            loginData.accessToken
        ];
        try {
            await callAPIWhileSettingState(importingCSVFile, paramsArray,
                setProcessingCSVFile, onCSVImported);
        } catch (error) {
            setDialogOpen(true);
            setDialogError('Failed to import csv: ' + error.message);
        } finally {
            e.target.value = null;
        }
    }

    const onCSVImported = () => {
        setDialogOpen(true);
        setDialogError(null);
    }

    const handleDialogClose = () => {
        setDialogOpen(false);
        setDialogError(null);
    };

    const handleClickCSVFileUpload = () => {
        csvFileInputRef.current.click();
    };

    const buttonsConfig = [
        {
            label: 'Select CSV File',
            onClick: handleClickCSVFileUpload,
            icon: <FileUpload />,
            disabled: processingCSVFile,
            isLoading: processingCSVFile,
            disabledText: 'Processing CSV file'
        },
    ];

    return (
        <div className="labels-csv-import-page">
            <Banner message="Languages Menu: Import CSV" />
            <B2BFormContainer title="Import CSV File" className="labels-csv-import-form" buttonsConfig={buttonsConfig}>
                <p>Expected order is: locale | label | description</p>
                <p>Example:     en|test.key.1|In English</p>
                <Divider orientation='horizontal' flexItem variant='fullWidth' />
                <div className='labels-csv-parameters'>
                    <div className="parameter-block">
                        <p>Column Separator: </p>
                        <input
                            type="text"
                            value={columnSeparator}
                            onChange={(e) => setColumnSeparator(e.target.value)}
                        />
                    </div>
                    <div className="parameter-block">
                        <p>Prioritize CSV: </p>
                        <Checkbox
                            checked={prioritizeCSV}
                            onChange={(e) => setPrioritizeCSV(e.target.checked)}
                        />
                    </div>
                </div>
                <input
                    ref={csvFileInputRef}
                    type="file"
                    style={{ display: 'none' }}
                    onChange={handleCSVFileUpload}
                />
                <B2BDialog
                    open={dialogOpen}
                    onClose={handleDialogClose}
                    title={dialogError ? 'Error importing CSV' : 'CSV Imported'}
                >
                    <p>{dialogError || "The csv file has been imported successfully."}</p>
                </B2BDialog>
            </B2BFormContainer>
        </div>
    );
};

export default CSVImportPage;